import React, { ReactNode } from 'react';

export interface TableWrapperProps {
  children?: ReactNode | undefined;
  hasScroll: boolean;
}

function TableWrapper(props: TableWrapperProps) {
  return (
    <div className="wrapper-ink-table">
      {props.hasScroll ? <div className="wrapper-ink-table--scroll">{props.children}</div> : props.children}
    </div>
  );
}

TableWrapper.defaultProps = {
  hasScroll: false,
};

export default TableWrapper;
